export default __webpack_public_path__ + "static/media/AddCreditzAudio.9ba34673.jpg";